'use client';

import Image from 'next/image';
import {useEffect, useRef, useState} from 'react';

import {Button} from './ui/button';
import {PartnerCard} from './ui/partnerCard';

type PartnersProps = {
    title: string;
    subTitle: string;
    partners: any[];
};

export default function Partners(props: PartnersProps) {
    const [showAll, setShowAll] = useState<boolean>(false);
    const handleShowAll = () => {
        setShowAll((prev) => !prev);
    };
    const containerRef = useRef<HTMLDivElement>(null);

    const partners = props.partners ?? [];
    useEffect(() => {
        const container = containerRef.current;
        if (container) {
            container.style.display = showAll ? 'grid' : 'flex';
            if (window.innerWidth < 640) {
                container.style.gridTemplateColumns = showAll
                    ? 'repeat(2, 1fr)'
                    : 'auto';
            } else if (window.innerWidth <= 820) {
                container.style.gridTemplateColumns = showAll
                    ? 'repeat(3, 1fr)'
                    : 'auto';
            } else if (window.innerWidth >= 1920) {
                container.style.gridTemplateColumns = showAll
                    ? 'repeat(6, 1fr)'
                    : 'auto';
            } else {
                container.style.gridTemplateColumns = showAll
                    ? 'repeat(4, 1fr)'
                    : 'auto';
            }
        }
    }, [showAll]);

    if (partners.length === 0) return null;

    const productDisplay = partners
        .slice(0, showAll ? partners.length : 8)
        .map((partner, index) => <PartnerCard key={index} partner={partner}/>);

    return (
        // pl-5 md:pl-11 lg:pl-20
        <section className=" flex flex-col gap-10 ">
            <div className="flex w-full flex-col  justify-between   sm:flex-row  ">
        <span className="flex flex-col">
          <h3 className=" font-garnettSemiBold">{props.title}</h3>
          <h6 className="m-0 text-sm">{props.subTitle}</h6>
        </span>
                <div className="flex justify-between gap-2">
          <span className="flex gap-2">
            <Button className="sliderBtn" variant="ghost" size="icon">
              <Image
                  src="/assets/svgs/Icons/CaretDown.svg"
                  width={16}
                  height={16}
                  alt="caret"
                  className=" rotate-90 "
              />
            </Button>
            <Button variant="ghost" size="icon" className="sliderBtn">
              <Image
                  src="/assets/svgs/Icons/CaretDown.svg"
                  width={16}
                  height={16}
                  alt="caret"
                  className=" -rotate-90 "
              />
            </Button>
          </span>
                    <Button
                        className="p-2 text-sm font-medium"
                        variant="ghost"
                        onClick={handleShowAll}
                    >
                        {showAll ? 'Show Less' : 'Show All'}
                    </Button>
                </div>
            </div>
            <div
                className="flex snap-mandatory gap-6 overflow-scroll py-4"
                ref={containerRef}
            >
                {productDisplay}
            </div>
        </section>
    );
}
